import { render } from "./DraftsList.vue?vue&type=template&id=7b5f832c"
import script from "./DraftsList.vue?vue&type=script&lang=js"
export * from "./DraftsList.vue?vue&type=script&lang=js"

import "./DraftsList.vue?vue&type=style&index=0&id=7b5f832c&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__